// Silent defaults · A-29 — the ISQM dashboard line for remediations with no target date (they are no longer counted as
// "On track"). New component next to ISQM.jsx (big-file rule); renders nothing for a server that has no such bucket.
import React from "react";

export default function IsqmNoTargetDateRow({ rem, t }) {
  const b = rem?.no_target_date;
  if (!b) return null;
  return (
    <div className="flex items-center justify-between text-sm" data-testid="isqm-dash-no-target-date">
      <span className="text-slate-600 dark:text-slate-400">{t("sd.noTargetDate")}</span>
      <span className="text-lg font-semibold tabular-nums" data-testid="isqm-dash-no-target-date-count">{b.count || 0}</span>
    </div>
  );
}
